var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "miniProgram w1200" }, [
    _c("ul", { staticClass: "program-type flex justify-center" }, [
      _c("li", [
        _c("h1", { staticClass: "text-center" }, [
          _vm._v("已经拥有微信小程序")
        ]),
        _vm._m(0),
        _c(
          "div",
          { staticClass: "text-center" },
          [
            _c(
              "el-button",
              {
                staticClass: "mar20-t",
                attrs: { type: "primary" },
                on: { click: _vm.openAuthorization }
              },
              [_vm._v("授权微信小程序")]
            )
          ],
          1
        )
      ]),
      _c(
        "li",
        [
          _c("h1", { staticClass: "text-center" }, [
            _vm._v("还没有微信小程序")
          ]),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c("el-tab-pane", { attrs: { label: "品牌小程序", name: "1" } }, [
                _c("p", [
                  _vm._v("提交认证信息，快速创建小程序，支持模板选择~")
                ]),
                _c("p", [
                  _vm._v(
                    "注：涉及法人相关的刷脸、验证码验证等(工商部备案、微信平台认证等)"
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "mar20-t",
                        attrs: { type: "primary" },
                        on: { click: _vm.openReg }
                      },
                      [_vm._v("快速注册小程序")]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "el-tab-pane",
                { attrs: { label: "通用小程序", name: "2" } },
                [
                  _c(
                    "el-form",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.shareLoading,
                          expression: "shareLoading"
                        }
                      ],
                      ref: "form",
                      staticClass: "mar50-r",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.rules,
                        "label-width": "100px",
                        "label-suffix": "：",
                        "element-loading-text": "上传中"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "经营描述", prop: "shareDesc" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "20",
                              placeholder: "请输入经营描述,20字以内"
                            },
                            model: {
                              value: _vm.form.shareDesc,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shareDesc", $$v)
                              },
                              expression: "form.shareDesc"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "分享图", prop: "shareImg" } },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "share-uploader",
                              attrs: {
                                action:
                                  _vm.env.VUE_APP_fileserver +
                                  "persistentUpload",
                                "show-file-list": false,
                                "on-success": _vm.uploadSuccess,
                                "before-upload": _vm.uploadBefore
                              }
                            },
                            [
                              _vm.form.shareImg
                                ? _c("img", {
                                    staticClass: "avatar",
                                    attrs: { src: _vm.form.shareImg }
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon"
                                  })
                            ]
                          ),
                          _c("div", { staticClass: "gray9 lh20" }, [
                            _vm._v("建议尺寸500px*400px")
                          ])
                        ],
                        1
                      ),
                      _c("el-form-item", { attrs: { label: "分享预览" } }, [
                        _c(
                          "div",
                          { staticClass: "pad15 radius10 bg-f2 lh20 w205" },
                          [
                            _c("div", { staticClass: "flex items-center" }, [
                              _c("div", { staticClass: "share-icon mar10-r" }),
                              _c("div", { staticClass: "f14 gray6" }, [
                                _vm._v("下单易助手")
                              ])
                            ]),
                            _c(
                              "div",
                              { staticClass: "mar10-tb f15 gray3 ellipsis2" },
                              [_vm._v(_vm._s(_vm.form.shareDesc))]
                            ),
                            _c(
                              "div",
                              { staticClass: "bg-white share-img radius5" },
                              [
                                _vm.form.shareImg
                                  ? _c("img", {
                                      attrs: { src: _vm.form.shareImg }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ]),
                      _c(
                        "el-form-item",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", loading: _vm.loading },
                              on: { click: _vm.submitForm }
                            },
                            [_vm._v("确定创建")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mar64-t" }, [
      _c("p", [
        _vm._v("授权已有的微信小程序，完成设置发布，快速获得商城小程序")
      ]),
      _c("p", [_vm._v("支持模板选择~")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }